import React, { useEffect, useState } from "react";
import { Layout, Col, Row, Button, Image } from "antd";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Post } from "../../config/api/post";
import { RESET } from "../../config/constants/api";
import Logofull from "../../assets/luxurycarlogo.png";
import facebook from "../../assets/authfb.png";
import twitter from "../../assets/twitter.png";
import google from "../../assets/google.png";
import VerificationInput from "react-verification-input";

import swal from "sweetalert";
import { Link } from "react-router-dom";

function Login() {
  const location = useLocation();
  // const [loading, setLoading] = useState(false);
  const [code, setCode] = useState(null);
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.userToken);
  const email = location?.state?.email;
  useEffect(() => {
    if (!email) {
      navigate("/forgotPassword");
    }
    // eslint-disable-next-line
  }, []);
  const handleSubmit = () => {
    Post(RESET.verifyCode, { email: email, code: code, type:'CHAUFFEUR' }, token)
      .then((response) => {
        if (response?.status) {
          swal("Success", response?.message, "success");
        }
        navigate("/forget-password-3", { state: { email: email, code: code } });
      })
      .catch((err) => {
        console.log("Error", err);
        swal("Error", err?.response?.data?.message, "error");
      });
  };
  return (
    <Layout
      className=""
      style={{ backgroundColor: "#fff", minHeight: "100vh" }}
    >
      <div className="">
        <Row
          style={{
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Col xs={0} md={0} lg={12}>
            <div className="auth-left-bg">
              <Link>
                <Image
                  preview={false}
                  alt={"Failed to load image"}
                  width={46}
                  height={46}
                  src={facebook}
                  style={{ maxWidth: "46px" }}
                />
              </Link>
              <Link>
                <Image
                  preview={false}
                  alt={"Failed to load image"}
                  width={46}
                  height={46}
                  src={twitter}
                  style={{ maxWidth: "46px" }}
                />
              </Link>
              <Link>
                <Image
                  preview={false}
                  alt={"Failed to load image"}
                  width={46}
                  height={46}
                  src={google}
                  style={{ maxWidth: "46px" }}
                />
              </Link>
            </div>
          </Col>
          <Col xs={23} md={23} lg={12}>
            <div className="auth-box">
              <div className="blur-bg-inner-card-form login-screen-form">
                <div style={{ textAlign: "center" }}>
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    // width={90}
                    // height={90}
                    src={Logofull}
                    // style={{ maxWidth: 100 }}
                  />
                </div>
                <h2 className="auth-heading">Forgot Password</h2>
                <p className="auth-p">
                  Enter verification code sent to your email address
                </p>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <VerificationInput
                    length={4}
                    placeholder="_"
                    validChars="0-9"
                    inputProps={{ inputMode: "numeric" }}
                    onChange={(val) => {
                      setCode(val);
                    }}
                  />
                </div>
                <div style={{ textAlign: "center" }}>
                  <Button
                    className={`${code?.length !== 4 ? "web-btn3" : "web-btn"}`}
                    style={{
                      cursor: "pointer",
                      marginTop: "20px",
                    }}
                    onClick={handleSubmit}
                    disabled={code?.length !== 4}
                  >
                    Continue
                  </Button>
                  <div
                    className="already-account-text"
                    style={{ textAlign: "center" }}
                  >
                    Already Have An Account?{" "}
                    <span onClick={() => navigate("/")}>
                      Back to Login
                    </span>{" "}
                  </div>
                </div>
                
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Layout>
  );
}

export default Login;
